import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { getId } from "../../../Components/Functions/word.fun";
import { FaCheckCircle } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
import WhatsAppButton from "../../../Components/layouts/whatsApp_button";
import { useDispatch, useSelector } from "react-redux";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcPanorama } from "react-icons/fc";
import { loginSuccess } from "../../../redux/user/loginReducer";

const ViewSiteInspection = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((store) => store.login.user);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);

    dispatch(
      loginSuccess({
        ...user,
        step: 0,
        submissionId: "",
      })
    );
    performRequest("GET", `/siteInspection/getSiteInspectionById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting SI!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const generatePDF = () => {
    if (!data?.quotationNumber) {
      alert(
        "For this site inspection quotation doesn't exist! Please add quotation and then generate DPR"
      );
    } else {
      navigate(`/client-site-inspection/preview/${id}`);
    }
  };
  const generateAIFPDF = () => {
    if (!data?.aifQuotationNumber || !data?.borrowFromBank) {
      alert(
        "For this site inspection AIF quotation doesn't exist! or borrow from bank not added! Please add quotation and then generate DPR"
      );
    } else {
      navigate(`/client-site-inspection-aif/preview/${id}`);
    }
  };

  function formatCamelCaseToWords(camelCaseString) {
    if (camelCaseString) {
      const formattedString = camelCaseString.replace(/([A-Z])/g, " $1").trim();
      const capitalizedString = formattedString
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return capitalizedString;
    } else {
      return "";
    }
  }

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">
                  <FcPanorama className="fs-2 me-1" />
                  Site Inspection
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-2">
            <div className="card-header">
              <h2 className="page-title">
                {data?.siNumber || "View Site Inspection"}
              </h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <h2 className="w-25  col-3">Project</h2>
                  <div className="w-100 col">
                    {(
                      data?.clientDetails?.clientName || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              <hr />
              <h2>Promoter Details</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Name</label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.name || "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Date Of Birth</label>
                  <div className="w-100 col">
                    {data?.newSiteInspection?.dateOfBirth || "NOT AVAILABLE"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Highest Qualification
                  </label>
                  <div className="w-100 col">
                    {data?.newSiteInspection?.highestQualification?.toUpperCase() ||
                      "NOT AVAILABLE"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Current Profession
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.currentProfession ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Experience With Farming
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.experienceWithFarming ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Cast</label>
                  <div className="w-100 col">
                    {(data?.cast || "NOT AVAILABLE").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Gender</label>
                  <div className="w-100 col">
                    {(
                      data?.projectOwnerGender || "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              <hr />

              <h2>Site Details</h2>
              <hr></hr>
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Application Type
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.applicationType ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Site address</label>
                  <div className="w-100 col">
                    {(
                      `${data?.newSiteInspection?.siteAddressLine1}, ${data?.newSiteInspection?.siteAddressLine2}` ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">City</label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.city || "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">State</label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.state || "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Pincode</label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.sitePinCode || "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    How will you identify this site location?
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.identitfyLocation ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Location Identification
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.locationIdentification ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Type Of Site</label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.typeOfSite || "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Latitude & Longitude
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.land?.googleMapsLocationLink || "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              <hr />

              <h2>Manangement Details</h2>
              <hr></hr>
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Tentative Start Date
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.tentativeStartDate ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site Manager Appointed
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.siteManagerAppointed ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site Mananger Name
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.siteManagerName ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site Manager Phone
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.siteManagerName ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Number of staff
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.numberOfStaff || "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              <hr />

              <h2>Land Details</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Soil type</label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(
                        data?.newSiteInspection?.soilType
                      ) || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Total available area unit
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.totalAvailableAreaUnit ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Total available area number
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.totalAvailableAreaNumber ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Land ownership
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.landOwnership || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Land leveling</label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.landLeveling || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Natural slope of land
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(
                        data?.newSiteInspection?.naturalSlopeOfLand
                      ) || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Land has tree</label>
                  <div className="w-100 col">
                    {data?.land?.landHasTree ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Land has stones
                  </label>
                  <div className="w-100 col">
                    {data?.land?.landHasStones ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Land has pond</label>
                  <div className="w-100 col">
                    {data?.land?.landHasPond ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Land has mud patch
                  </label>
                  <div className="w-100 col">
                    {data?.land?.landHasMudPatch ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Land has hill lock
                  </label>
                  <div className="w-100 col">
                    {data?.land?.landHasHillock ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}

              <hr />
              <h2>Water Details</h2>
              <hr />

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Mark water not available
                  </label>
                  <div className="w-100 col">
                    {data?.water?.markWaterNotAvailable ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water source type
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.water?.waterSourceType || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water tank capacity in litre
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.water?.waterTankCapacityInLitre || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water availability frequency
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(
                        data?.water?.waterAvailabilityFrequency
                      ) || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Position of water tank
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.water?.positionOfWaterTank || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water tank location photo
                  </label>
                  <div className="w-100 col">
                    {data?.water?.waterTankLocationPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.water?.waterTankLocationPhoto}
                        alt={"water tank location photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water Ph reading
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.water?.waterPhReading || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water Ec reading
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.water?.waterEcReading || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water report photo
                  </label>
                  <div className="w-100 col">
                    {data?.water?.waterReportPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.water?.waterReportPhoto}
                        alt={"water report photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              <hr />
              <h2>Sunlight</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Entry to farm site
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.sunlight?.entryToFarmSite || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Entry to farm photo
                  </label>
                  <div className="w-100 col">
                    {data?.sunlight?.entryTofarmPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.sunlight?.entryTofarmPhoto}
                        alt={"entry to farm photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Lux reading</label>
                  <div className="w-100 col">
                    {(
                      data?.sunlight?.luxReading || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lux reading photo
                  </label>
                  <div className="w-100 col">
                    {data?.sunlight?.luxReadingPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.sunlight?.luxReadingPhoto}
                        alt={"lux reading photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lux deffusion sheet
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.sunlight?.luxDeffusionSheet || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lux deffusion sheet photo
                  </label>
                  <div className="w-100 col">
                    {data?.sunlight?.luxDeffusionSheetPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.sunlight?.luxDeffusionSheetPhoto}
                        alt={"lux deffusion sheet photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lux woven poly
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.sunlight?.luxWovenPoly || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lux woven poly photo
                  </label>
                  <div className="w-100 col">
                    {data?.sunlight?.luxWovenPolyPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.sunlight?.luxWovenPolyPhoto}
                        alt={"lux woven poly photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Lux Uv open</label>
                  <div className="w-100 col">
                    {(
                      data?.sunlight?.luxUvOpen || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Lux Uv open photo
                  </label>
                  <div className="w-100 col">
                    {data?.sunlight?.luxUvOpenPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.sunlight?.luxUvOpenPhoto}
                        alt={"lux uv open photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              <hr />
              <h2>Climate Details</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Temperature reading
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.climate?.temperatureReading || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Temperature reading photo
                  </label>
                  <div className="w-100 col">
                    {data?.climate?.temperatureReadingPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.climate?.temperatureReadingPhoto}
                        alt={"temperature reading photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Humidity reading
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.climate?.humidityReading || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Humidity reading photo
                  </label>
                  <div className="w-100 col">
                    {data?.climate?.humidityReadingPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.climate?.humidityReadingPhoto}
                        alt={"humidity reading photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Climate hottest month
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.climate?.climateHottestMonth || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Climate coldest month
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.climate?.climateColdestMonth || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              <hr />
              <h2>Dimensions Details</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Land fencing type
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.land?.landFencingType || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Land fencing height in feet
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.land?.landFencingHeightInFeet || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Whats on north
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(data?.land?.whatsOnNorth) ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Whats on east</label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(data?.land?.whatsOnEast) ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Whats on south
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(data?.land?.whatsOnSouth) ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Whats on west</label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(data?.land?.whatsOnWest) ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Obstacles towards sky
                  </label>
                  <div className="w-100 col">
                    {data?.land?.obstaclesTowardsSky ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Obstacles towards sky photo
                  </label>
                  <div className="w-100 col">
                    {data?.land?.obstaclesTowardsSkyPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.land?.obstaclesTowardsSkyPhoto}
                        alt="obstacles towards sky photo"
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Layout photo</label>
                  <div className="w-100 col">
                    {data?.dimensions?.layoutPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.dimensions?.layoutPhoto}
                        alt={"layout Photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Polyhouse costruction layout
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.costructionLayout ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.dimensions?.costructionLayout}
                        alt={"layout Photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Polyhouse system layout
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.systemLayout ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.dimensions?.systemLayout}
                        alt={"layout Photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Polyhouse - end view (Big column)
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.pEndView ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.dimensions?.pEndView}
                        alt={"layout Photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Polyhouse - center view (No big column)
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.pCenterView ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.dimensions?.pCenterView}
                        alt={"layout Photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Polyhouse - side view
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.pSideView ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.dimensions?.pSideView}
                        alt={"layout Photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )} */}
              <hr />
              <h2>Measurement Details</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    North south measurment in meter
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.dimensions?.northSouthMeasurmentInMeter ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    North south measurment photo
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.northSouthMeasurmentPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.dimensions?.northSouthMeasurmentPhoto}
                        alt={"north South Measurment Photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    North south measurment video
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.northSouthMeasurmentViedo ? (
                      <video width="70%" controls>
                        <source
                          src={data?.dimensions?.northSouthMeasurmentViedo}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    East west measurment in meter
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.dimensions?.eastWestMeasurmentInMeter ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    East west measurment photo
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.eastWestMeasurmentPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.dimensions?.eastWestMeasurmentPhoto}
                        alt={"east West Measurment Photo"}
                      />
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    East west measurment viedo
                  </label>
                  <div className="w-100 col">
                    {data?.dimensions?.eastWestMeasurmentViedo ? (
                      <video width="70%" controls>
                        <source
                          src={data?.dimensions?.eastWestMeasurmentViedo}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              <hr />

              <h2>Facilities</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Facility to store items
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.facilityToStoreItems ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Facility to stay
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.facilityToStay ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Facility has bathroom
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.facilityHasBathroom ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Facility has drinking water
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.facilityHasDrinkingWater ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Facility has kitchen space
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.facilityHasKitchenSpace ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Facility has fuel for cooking
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.facilityHasFuelForCooking ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              <hr />
              <h2>Transport Options</h2>
              <hr />

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Transport option
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(
                        data?.facilities?.transportOption
                      ) || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest tar road
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestTarRoad || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Regular mode of transportation
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(
                        data?.facilities?.regulerModeOfTransportation
                      ) || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vehicle avilable for emergency
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.vehicleAvilableForEmergency ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              <hr />
              <h2>Neares Facilities</h2>
              <hr />

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest market
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestMarket || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest medical facility
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestMedicalFacility ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest stay facility
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestStayFacility || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest bus stand
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestBusStand || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest railway station
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestRailwayStation || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest airport
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestAirport || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest tier-1 city
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestTier1City || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest tier-1 city distance (kms)
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.nearestTier1CityDistance ||
                      "NOT AVAILABLE"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest tier-2 city
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.nearestTier2City || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Nearest tier-2 city distance (kms)
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.nearestTier2CityDistance ||
                      "NOT AVAILABLE"}
                  </div>
                </div>
              )}

              <hr />
              <h2>Electriricty Details</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Electricity connection available
                  </label>
                  <div className="w-100 col">
                    {data?.facilities?.electricityConnectionAvailable ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Electricity meter type
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.electricityMeterType || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Electricity meter phase type
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(
                        data?.facilities?.electricityMeterPhaseType
                      ) || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Electricity outage frequency
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.electricityOutageFrequency ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Electricity unit price
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.electricityUnitPrice || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Electricity pricing model
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.facilities?.electricityPricingModel ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Electricity usage
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(
                        data?.facilities?.electricityUsage
                      ) || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Internet connectivity
                  </label>
                  <div className="w-100 col">
                    {(
                      formatCamelCaseToWords(
                        data?.facilities?.internetConnectivity
                      ) || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              <hr />
              <h2>Financial Details</h2>
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Average labour salary (monthly)
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.averageLabourSalary ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Monthly leased amount
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.monthlyLeasedAmount ||
                      "NOT AVAILABLE"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Quotation</label>
                  <div className="w-100 col">
                    {data?.quotationNumber ? (
                      <a
                        href={
                          data?.quotationNumber.includes("A/V2")
                            ? `/custom-quotation-v2/${getId(
                                data?.quotationNumber
                              )}`
                            : `/custom-quotation/${getId(
                                data?.quotationNumber
                              )}`
                        }
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {data?.quotationNumber}
                      </a>
                    ) : (
                      "Not Available"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">AIF quotation</label>
                  <div className="w-100 col">
                    {data?.aifQuotationNumber ? (
                      <a
                        href={
                          data?.aifQuotationNumber.includes("A/V2")
                            ? `/custom-quotation-v2/${getId(
                                data?.aifQuotationNumber
                              )}`
                            : `/custom-quotation/${getId(
                                data?.aifQuotationNumber
                              )}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {data?.aifQuotationNumber}
                      </a>
                    ) : (
                      "Not Available"
                    )}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Project funding plan
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.projectFundingPlan ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Looking for loan
                  </label>
                  <div className="w-100 col">
                    {data?.newSiteInspection?.lookingForLoan ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Loan banks</label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.loanBanks || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Future expectation from plan
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.futureExpectationFromPlan ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Primary Loan Bank
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.primaryLoanBank ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Primary Loan Bank IFSC
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.primaryLoanIfsc ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Secondary Loan Bank
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.secondaryLoanBank ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Secondary Loan Bank IFSC
                  </label>
                  <div className="w-100 col">
                    {(
                      data?.newSiteInspection?.secondaryLoanIfsc ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}

              <hr />
              <hr />
              <h2>Additional Details</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Description video
                  </label>
                  <div className="w-100 col">
                    {data?.additionDetails?.descriptionVideo ? (
                      <div className="ratio ratio-1x1" style={{ width: "70%" }}>
                        <video
                          controls
                          className="w-100 h-100"
                          style={{ objectFit: "cover" }}
                        >
                          <source
                            src={data?.additionDetails?.descriptionVideo}
                            type="video/mp4"
                          />
                        </video>
                      </div>
                    ) : (
                      "Not Available".toUpperCase()
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Remarks</label>
                  <div className="w-100 col">
                    {(
                      data?.additionDetails?.notes || "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Marked site not feasible
                  </label>
                  <div className="w-100 col">
                    {(data?.additionDetails?.markSiteNotFeasible
                      ? "Not Feasible"
                      : "Feasible"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && data?.additionDetails?.markSiteNotFeasible && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Notes</label>
                  <div className="w-100 col">
                    {(
                      data?.additionDetails?.reasonOfNonFeasibility ||
                      "Not Available"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              <hr />
              <h2>AIF Details</h2>
              <hr />
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Applied for AIF DPR
                  </label>
                  <div className="w-100 col">
                    {data?.appliedForAIFDPR ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Borrow from bank
                  </label>
                  <div className="w-100 col">
                    {data?.borrowFromBank || "Not Available"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Tenure</label>
                  <div className="w-100 col">
                    {data?.tenure || "Not Available"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Rate of interest
                  </label>
                  <div className="w-100 col">
                    {data?.rateOfInt || "Not Available"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Funding amount type
                  </label>
                  <div className="w-100 col">
                    {data?.fundingAmmountType || "Not Available"}
                  </div>
                </div>
              )}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                {user.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                  user.Role !== process.env.REACT_APP_ROLE_D_CLIENT && (
                    <WhatsAppButton buttonText="SEND UPDATE" />
                  )}
                <SimpleButton
                  buttonText={"generate pdf"}
                  onClick={generatePDF}
                />
                <SimpleButton
                  buttonText={"generate AIF pdf"}
                  onClick={generateAIFPDF}
                />
                {/* {user.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                  user.Role !== process.env.REACT_APP_ROLE_D_CLIENT && (
                    <SimpleButton
                      buttonText="Edit Site Inspection"
                      href={`/client-site-inspection/edit/${id}`}
                    />
                  )} */}
                <SimpleButton
                  buttonText="Edit Site Inspection"
                  href={`/client-site-inspection/edit/${id}`}
                />
                {/* {user.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                  user.Role !== process.env.REACT_APP_ROLE_D_CLIENT && (
                    <SimpleButton
                      buttonText="Create Bankable DPR"
                      data-bs-toggle="modal"
                      data-bs-target="#modal-team"
                    />
                  )}
                <div
                  className="modal modal-blur fade"
                  id={`modal-team`}
                  tabIndex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <Formik
                    initialValues={CreateBankingDpr}
                    validationSchema={CreateBankingDprSchema}
                    enableReinitialize
                  >
                    {(props) => (
                      <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
                        <div className="modal-dialog modal-dialog-centered w-100">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Add Items</h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <div className="mb-3">
                                <label className="form-label required">
                                  Borrow From Bank
                                </label>
                                <CustomSelect
                                  type="number"
                                  name="borrowFromBank"
                                >
                                  <option value="">Select</option>
                                  <option value={0}>0%</option>
                                  <option value={25}>25%</option>
                                  <option value={50}>50%</option>
                                  <option value={75}>75%</option>
                                  <option value={100}>100%</option>
                                </CustomSelect>
                                {props.touched.borrowFromBank &&
                                  props.errors.borrowFromBank && (
                                    <p className="text-danger">
                                      {props.errors.borrowFromBank}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                              >
                                Close
                              </button>
                              <SimpleButton
                                buttonText="Submit"
                                data-bs-dismiss="modal"
                                onClick={() => handleSubmit(props.values)}
                              />
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div> */}
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewSiteInspection;
